import { configureStore } from "@reduxjs/toolkit"
import dagsReducer from "./actions/dags.actions"

export default configureStore({
  reducer: {
    dags: dagsReducer,
  },
})
